export interface TableColumn {
  key: string;
  label?: string;
  isHugContent?: boolean;
  isSortable?: boolean;
  tdClass?: string;
  initialSortDirection?: SORTING;
}

export enum SORTING {
  DESC = 'desc',
  ASC = 'asc',
  NOT_SORTED = ''
}
